<script lang="ts">
  import KeyboardKey from "app/ui/KeyboardKey.svelte";
  import type {
    KeybindItem,
    SearchResultItemProps,
  } from "../SearchControllers";

  let { density, resultItem, selected, callAction }: SearchResultItemProps =
    $props();

  let item = resultItem.item as KeybindItem;
</script>

<li class:search-selected={selected} class="no-icon-result" title={item.name}>
  <a onclick={(e) => callAction({ item, shiftKey: e.shiftKey })}>
    <span>{item.name}</span>
    <span class="secondary">
      {#if density === "spacious" && item.description}
        <span class="sub">{item.description}</span>
      {/if}
      {#each item.keybinds as bind}
        <KeyboardKey>{bind}</KeyboardKey>
      {/each}
    </span>
  </a>
</li>

<style>
  :global(.density-spacious) a {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }
  .secondary {
    display: flex;
    flex-direction: row;
    justify-content: end;
    flex-shrink: 0;
    gap: 0.4em;
  }
</style>
